import React from 'react';
import { Star, Users, Calendar, Award } from 'lucide-react';

const SocialProof = () => {
  const stats = [
    {
      icon: Users,
      number: "500+",
      label: "Happy Customers"
    },
    {
      icon: Calendar,
      number: "15+",
      label: "Years Experience"
    },
    {
      icon: Star,
      number: "4.9",
      label: "Average Rating"
    },
    {
      icon: Award,
      number: "100%",
      label: "Satisfaction Rate"
    }
  ];

  return (
    <section className="py-12 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-500/20 rounded-xl mb-3">
                <stat.icon className="w-6 h-6 text-amber-400" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.number}</div>
              <div className="text-slate-400 text-sm md:text-base">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
